export default __webpack_public_path__ + "static/media/EarnMoney.fbe8ec43.svg";